import { render } from "./PageA.vue?vue&type=template&id=6b7a283a&scoped=true"
import script from "./PageA.vue?vue&type=script&lang=js"
export * from "./PageA.vue?vue&type=script&lang=js"

import "./PageA.vue?vue&type=style&index=0&id=6b7a283a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7a283a"]])

export default __exports__